import { ReactNode, ComponentProps } from 'react'

import { Td, TdLabel } from 'app/common/ui-components/table'

/**
 * Ячейка таблицы Td с условным вариантом label
 *
 * При валидном htmlFor и !onlyTd включает/выключает
 * соответствующий элемент (checkbox или radio)
 * при нажатии на эту ячейку */

export const TdWithLabel = ({
  children,
  htmlFor,
  onlyTd = false,
  ...props
}: {
  htmlFor?: string
  onlyTd?: boolean
} & ComponentProps<typeof Td>) =>
  htmlFor && !onlyTd ? (
    <TdLabel htmlFor={htmlFor} {...props}>
      {children}
    </TdLabel>
  ) : (
    <Td {...props}>{children}</Td>
  )
